
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team",
      function () {
        return require("private-next-pages/team/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team"])
      });
    }
  